import React, { Component, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Popup, Icon } from "semantic-ui-react";

class LabelWithHelpPopup extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  // -- RENDER -- //

  render() {
    const { label, help } = this.props;

    return (
      <Fragment>
        {label}{" "}
        {help && (
          <Popup
            trigger={<Icon name="help circle" className="info" />}
            content={help}
            position="top right"
            offset={[11, 0]}
            wide
          />
        )}
      </Fragment>
    );
  }
}

export default LabelWithHelpPopup;
